/* eslint-disable react/jsx-key */
import React, { createRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { TableScrollButtons } from './TableScrollButtons';
import { useIsScrollable } from '../../../../../../../common/react/hooks/use-is-scrollable';

const SCROLL_DEBOUNCE_MS = 100;

export const StatsTable = ( {
    children,
    getTableProps,
    nextPageButton,
    modifier,
    cssClass
} ) => {

    const scrollWrapperRef = createRef();

    const [ scrollPosition, setScrollPosition ] = useState( 0 );
    
    const isTableScrollable = useIsScrollable( scrollWrapperRef );

    return (
        <div className={ classNames( 'stats-table ' + ( cssClass ?? '' ), {
            'stats-table--is-scrollable': isTableScrollable,
            [ `stats-table--${ modifier }` ]: !!modifier
        } ) } >
            <div
                ref={ scrollWrapperRef }
                className="stats-table__wrapper"
                // @ts-ignore
                onScroll={ _.debounce( () => {
                    setScrollPosition(
                        scrollWrapperRef.current.scrollLeft
                    );
                }, SCROLL_DEBOUNCE_MS ) }
            >
                { isTableScrollable && (
                    <TableScrollButtons
                        scrollWrapperRef={ scrollWrapperRef }
                        scrollPosition={ scrollPosition }
                    />
                ) }

                <table
                    { ...getTableProps() }
                    className="stats-table__table"
                >
                    { children }
                </table>
            </div>
            { nextPageButton }
        </div>
    );
};

StatsTable.propTypes = {
    children: PropTypes.any.isRequired,
    getTableProps: PropTypes.func.isRequired,
    nextPageButton: PropTypes.any,
    modifier: PropTypes.string,
    cssClass: PropTypes.string
};